import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
import Style from "./EditProductSupperMarket.module.css";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import {
  getImagesAPi,
  PostExistFood,
  removeImageApi,
} from "../../Api/BarestSupplierServices";
import {faImages, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Resizer from "react-image-file-resizer";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import { AddBrandPostApi, getBrandListApi } from "../../Api/SupplierServices";
import Modal from "../../Components/Modal/Modal";
import { useHistory } from "react-router-dom";

const EditProductSupperMarket = (props) => {
    const [price, setPrice] = useState("");
    const [offPrice, setOffPrice] = useState("");
    const [name, setName] = useState("");
    const [count, setCount] = useState("");
    const [maxCount, setMaxCount] = useState("");
    const [weight, setWeight] = useState("");
    const [volume, setVolume] = useState("");
    const [barcode1, setBarcode1] = useState("");
    const [barcode2, setBarcode2] = useState("");
    const [barcode3, setBarcode3] = useState("");
    const [Describe, setDescribe] = useState("");
    const [files, setFiles] = useState([]);
    const [imgs, setImgs] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [disable, setDisable] = useState(false);
    const [englishbrand, setEnglishbrand] = useState([]);
    const [persianbrand, setPersianbrand] = useState([]);
    const [brands, setBrands] = useState([]);
    const [chooseBrand, setChooseBrand] = useState(props.location.state.data.brand_id);
    const [brandPersian, setBrandPersian] = useState(props.location.state.data.brand_persian);
    let history=useHistory()
    useEffect(() => {
        getImages();
        getBrandList()
        getProductDetail()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    ///////////////// get product detail ///////////
    const getProductDetail=async()=>{
        const result=await getImagesAPi(props.location.state.data.id)
        setPrice(result.product.price)
        setOffPrice(result.product.off_price)
        setName(result.product.name)
        setCount(result.product.count)
        setMaxCount(result.product.max_count)
        setWeight(result.product.weight)
        setVolume(result.product.volume)
        setBarcode1(result.product.barcode_1)
        setBarcode2(result.product.barcode_2)
        setBarcode3(result.product.barcode_3)
        setDescribe(result.product.other_detail)

    }
    
    const {
        handleSubmit,
    } = useForm();

    
    //////گرفتن عکس های قبلی محصول
    const getImages = async () => {
        const result = await getImagesAPi(props.location.state.data.id);
        setImgs(result.product.img);
    };
    ////////////حذف عکس
    const removeImage = (name) => {
        const info = {
            product_id: props.location.state.data.id,
        file: name,
    };
    removeImageApi(info, (res) => {
        getImages();
    });
    };
    const removeUploadImage = (name) => {
        setFiles((oldState) => oldState.filter((item) => item !== name));
    };
    const UploadImage = async (images) => {
        return await resizeFile(images);
    };

    const resizeFile = (file) => {
        for (let i = 0; i < file.length; i++) {
        Resizer.imageFileResizer(
            file[i],
            1024,
            1024,
            "WEBP",
            100,
            0,
            (uri) => {
                setFiles((prevfiles) => [...prevfiles, uri]);
            },
            "base64"
            );
        }
    };
    ////////////add brand ///////////////
    
    const getBrandList = async () => {
        const result = await getBrandListApi();
        setBrands(result.brand);
    };
    let brandOption =
    brands &&
    brands.map((item) => {
        return { value: item.id, label: item.brand_persian };
    })
    
    const AddBrandHandler = () => {
        setOpenModal(true);
    };
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const getBrandOnChange=(e)=>{
        setChooseBrand(e.value)
        setBrandPersian(e.label)
    }
    const sendNewBrand = () => {
        let info = {
            brand_persian: persianbrand,
          brand_english: englishbrand,
          file: "",
        };
        AddBrandPostApi(info, (res) => {
            if (res.status === 1) {
                succToast(res.message);
                setEnglishbrand("");
                setPersianbrand("");
            } else {
                errorToast("خطایی رخ داده است");
                setEnglishbrand("");
                setPersianbrand("");
            }
        });
        getBrandList();
    }
    const onSubmit = () => {
        setDisable(true)
        let info = {
            file: files,
            name: name,
            barcode_1: barcode1 === "" ? 0 : parseInt(barcode1),
            barcode_2: barcode2 === "" ? 0 : parseInt(barcode2),
            barcode_3: barcode3 === "" ? 0 : parseInt(barcode3),
            price: price === "" ? 0 : price,
            off_price: offPrice === "" ? 0 : offPrice,
            count: count === "" ? 0 : count,
            max_count: maxCount === "" ? 0 : maxCount,
            other_detail: Describe === "" ? "" : Describe,
            category_id: 27,
            brand_id: parseInt(chooseBrand),
            weight: weight === "" ? 0 : parseInt(weight),
            volume: volume === "" ? 0 : parseInt(volume),
            product_id: props.location.state.data.id,
        };
        PostExistFood(info, (succ) => {
        if (succ.status === 1) {
            succToast(succ.message);
            setDisable(false)
            setTimeout(() => {
                history.goBack()
            }, 500);
        } else {
            setDisable(false)
            errorToast(succ.message);
        }
        });
    };
    function randomNumberInRange(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    return (
        <div className={Style.PageHolder}>
        <MenuTitle title={"ویرایش و جزئیات محصول"} />
        <Modal show={openModal} modalClose={handleCloseModal} translate={40}>
            <div className={Style.FormAddProduct}>
            <input
                className={Style.fileInputPart2}
                placeholder={"نام برند به فارسی "}
                onChange={(e) => setPersianbrand(e.target.value)}
                value={persianbrand}
                />
            <input
                className={Style.fileInputPart2}
                placeholder={"نام برند به انگلیسی"}
                onChange={(e) => setEnglishbrand(e.target.value)}
                value={englishbrand} 
                />
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-around",
                    width: "50%",
                }}
                >
                <button
                className={Style.btnStyle}
                type={"submit"}
                onClick={sendNewBrand}
                >
                ثبت
                </button>
                <button
                className={Style.btnStyle}
                type={"submit"}
                onClick={handleCloseModal}
                >
                بستن
                </button>
            </div>
            </div>
        </Modal>
        <div className={Style.imageHolder}>
            <img src={"/Assets/Images/Product/editeProduct.svg"} alt="Product" />
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className={Style.FormHolder}>
            <div className={Style.imagePart}>
                {imgs.map((item, index) => {
                    return (
                        <div key={index} className={Style.eachImage}>
                        <div className={Style.picHolder}>
                        <img
                            src={`https://cdn.barest.ir/product/m/${item}.jpg?${randomNumberInRange(1,1000000000000)}`}
                            alt=""
                        />
                        </div>
                        <div
                        className={Style.iconHolder}
                        onClick={() => removeImage(item)}
                        >
                        <FontAwesomeIcon icon={faTrashAlt} />
                        </div>
                    </div>
                    );
                })}
                {files.map((item, index) => {
                    return (
                    <div key={index} className={Style.eachImage}>
                        <div className={Style.picHolder}>
                        <img src={item} alt="" />
                        </div>
                        <div
                        className={Style.iconHolder}
                        onClick={() => removeUploadImage(item)}
                        >
                        <FontAwesomeIcon icon={faTrashAlt} />
                        </div>
                    </div>
                    );
                })}
            </div>
            <div className={Style.inptFileHolder}>
                <label className={Style.lablePart} htmlFor="imgSelect">
                    <FontAwesomeIcon icon={faImages} />
                </label>
                <p className={Style.placeHolderInput}>بارگذاری تصویر</p>
                <input
                    className={Style.fileInputPart}
                    type="file"
                    id={"imgSelect"}
                    onChange={(e) => UploadImage(e.target.files)}
                    multiple
                />
            </div>
            <input
            className={Style.fileInputPart2}
            placeholder={" نام محصول"}
            value={name}
            onChange={(e)=>setName(e.target.value)}
            />
            <div className={Style.selectHolder}>
                <FontAwesomeIcon
                    icon={faPlus}
                    className={Style.plusIcon}
                    onClick={AddBrandHandler}
                />
                <Select
                    onChange={(e)=>getBrandOnChange(e)}
                    options={brandOption}
                    value = {
                        brandOption.filter(option => 
                           option.label === brandPersian)
                    }
                    className={Style.selectOptionsearch}
                    placeholder={"برند محصول"}
                />
            </div>
            <input
            className={Style.fileInputPart2}
            placeholder={"وزن به گرم"}
            value={weight}
            onChange={(e)=>setWeight(e.target.value)}
            />
            <input
            className={Style.fileInputPart2}
            placeholder={"حجم به میلی لیتر"}
            value={volume}
            onChange={(e)=>setVolume(e.target.value)}
            />

            <input
            className={Style.fileInputPart2}
            placeholder={"بارکد شماره یک"}
            value={barcode1}
            onChange={(e)=>setBarcode1(e.target.value)}
            />
            <input
            className={Style.fileInputPart2}
            placeholder={"بارکد شماره دو"}
            value={barcode2}
            onChange={(e)=>setBarcode2(e.target.value)}
            type="text"
            />
            <input
            className={Style.fileInputPart2}
            placeholder={"بارکد شماره سه"}
            value={barcode3}
            onChange={(e)=>setBarcode3(e.target.value)}
            type="text"
            />
            <input
            className={Style.fileInputPart2}
            placeholder={"حداکثر تعداد"}
            type="text"
            value={maxCount}
            onChange={(e)=>setMaxCount(e.target.value)}
            />
            <input
            className={Style.fileInputPart2}
            placeholder={"قیمت به تومان"}
            type="text"
            value={price}
            onChange={(e)=>setPrice(e.target.value)}
            />
            <input
            className={Style.fileInputPart2}
            placeholder={"قیمت با تخفیف به تومان"}
            type="text"
            value={offPrice}
            onChange={(e)=>setOffPrice(e.target.value)}
            />
            <input
            className={Style.fileInputPart2}
            placeholder={"تعداد"}
            type="text"
            value={count}
            onChange={(e)=>setCount(e.target.value)}
            />
            <textarea
            placeholder={"توضیحات تکمیلی"}
            className={Style.fileInputArea}
            value={Describe}
            onChange={(e)=>setDescribe(e.target.value)}
            />
            <button
            className={Style.btnStyle}
            disabled={disable}
            >ثبت</button>
        </form>
        </div>
    );
};

export default EditProductSupperMarket;
